module.exports = __webpack_public_path__ + "img/illustration.c4f6b477.svg";